import React, { useState, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { Messages } from 'primereact/messages';
import { useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './ResetPassword.css';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [processing, setProcessing] = useState(false);
  const navigate = useNavigate();
  const toast = useRef(null);

  const validateInputs = () => {
    if (newPassword.length > 8) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'La contraseña no puede tener más de 8 caracteres' });
      return false;
    }
    if (newPassword !== confirmPassword) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Las contraseñas no coinciden' });
      return false;
    }
    return true;
  };

  const handleResetPassword = async () => {
    if (!validateInputs()) {
      return;
    }

    try {
      setProcessing(true);

      const formData = new URLSearchParams();
      formData.append('email', email);
      formData.append('code', code);
      formData.append('newPassword', newPassword);
      formData.append('confirmPassword', confirmPassword);

      const response = await fetch(`/api/security/resetPassword`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData,
      });

      if (response.ok) {
        setMessage('Contraseña restablecida exitosamente');
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Contraseña restablecida exitosamente' });
        setTimeout(() => {
          setEmail('');
          setCode('');
          setNewPassword('');
          setConfirmPassword('');
          setProcessing(false);
          navigate('/');
        }, 4000);
      } else {
        const errorMessage = await response.text();
        setMessage(`Error: ${errorMessage}`);
        toast.current.show({ severity: 'error', summary: 'Error', detail: `Error: ${errorMessage}` });
        setProcessing(false);
      }
    } catch (error) {
      setMessage(`Error: ${error.message}`);
      toast.current.show({ severity: 'error', summary: 'Error', detail: `Error: ${error.message}` });
      setProcessing(false);
    }
  };

  const handleNavigateToHome = () => {
    navigate('/'); // Redirige al inicio de la aplicación
  };

  return (
    <div className="p-fluid reset-password-container">
      <div className="p-card reset-password-card">
        <h2 className="reset-password-header">Restablecer Contraseña</h2>
        <div className="p-field">
          <label htmlFor="email" className="p-d-block">Email</label>
          <InputText id="email" value={email} onChange={(e) => setEmail(e.target.value)} className="p-inputtext-lg" />
        </div>
        <div className="p-field">
          <label htmlFor="code" className="p-d-block">Código de Verificación</label>
          <InputText id="code" value={code} onChange={(e) => setCode(e.target.value)} className="p-inputtext-lg" />
        </div>
        <div className="p-field">
          <label htmlFor="newPassword" className="p-d-block">Nueva Contraseña</label>
          <Password
            id="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="p-inputtext-lg"
            toggleMask
            feedback={false} // Desactiva el feedback visual si no se necesita
          />
        </div>
        <div className="p-field">
          <label htmlFor="confirmPassword" className="p-d-block">Confirmar Nueva Contraseña</label>
          <Password
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="p-inputtext-lg"
            toggleMask
            feedback={false} // Desactiva el feedback visual si no se necesita
          />
        </div>
        <Button
          label="Restablecer Contraseña"
          onClick={handleResetPassword}
          className="p-button-lg p-button-primary p-mt-3"
          disabled={processing}
        />
        <Button
          icon="pi pi-home"
          className="p-button-outlined p-button-secondary p-button-lg p-mt-3"
          onClick={handleNavigateToHome}
          label="Regresar al Inicio"
        />
        <Messages severity="info" text={message} className="messages-container" />
      </div>
      <Toast ref={toast} />
    </div>
  );
};

export default ResetPassword;
